pageId = 'tr_wework-teams-install-callback'

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  progressUrl = $page.data('progress-url')
  if progressUrl
    $.getScript progressUrl
